import {
  ApiBankCell,
  ApiBond,
  ApiBrokerageAccount,
  ApiCentralizedWallet,
  ApiCommercialRealEstate,
  ApiCommodityAssetToken,
  ApiDebitAccount,
  ApiDecentralizedWallet,
  ApiExchangeOptions,
  ApiForwards,
  ApiFutures,
  ApiJewelry,
  ApiLand,
  ApiLegalEntity,
  ApiMetalAccount,
  ApiMyFund,
  ApiOverTheCounterOptions,
  ApiPreciousGemstones,
  ApiProfileSimpleResponse,
  ApiPublicFund,
  ApiResidentialRealEstate,
  ApiSecuritiesAndStocks,
} from '../generated/data-contracts';
import {
  ApiCreateWillParticipantDto,
  ApiProfileWithMainUserResponse,
  ApiScopeResponse,
} from '../generated/data-contracts';

export type IwRole = ApiCreateWillParticipantDto['role'];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type ApiCurrencyCode = any; // enum with currencies code

export const AccountStatus = {
  ACTIVE: 'ACTIVE',
  CREATED: 'CREATED',
  DELETED: 'DELETED',
  INACTIVE: 'INACTIVE',
} as const satisfies Record<
  ApiProfileWithMainUserResponse['status'],
  ApiProfileWithMainUserResponse['status']
>;

export type AccountStatus = ApiProfileWithMainUserResponse['status'];

export type AccountScopes = ApiScopeResponse['scopeType'][];

export type AiAsset =
  | ApiDebitAccount
  | ApiResidentialRealEstate
  | ApiCommercialRealEstate
  | ApiLand
  | ApiLegalEntity
  | ApiJewelry
  | ApiBankCell
  | ApiMetalAccount
  | ApiCentralizedWallet
  | ApiDecentralizedWallet
  | ApiPreciousGemstones
  | ApiCommodityAssetToken
  | ApiBrokerageAccount
  | ApiSecuritiesAndStocks
  | ApiBond
  | ApiExchangeOptions
  | ApiOverTheCounterOptions
  | ApiFutures
  | ApiForwards
  | ApiMyFund
  | ApiPublicFund;

// TODO: remove after moving to tenant profiles
export const ProfileType = {
  ASSISTANT: 'ASSISTANT',
  BENEFICIARY: 'BENEFICIARY',
  MAIN_USER: 'MAIN_USER',
} as const satisfies Record<ApiProfileSimpleResponse['type'], ApiProfileSimpleResponse['type']>;

export type ProfileType = keyof typeof ProfileType;
